import { Container, Button } from 'react-bootstrap';
import styled from 'styled-components';
import { BACKGROUND_COLOR, BLACK, HOVER_ITEM_COLOR, PRIMARY, WHITE } from '../../utils/colors';
import OrderTutorialBg from '../../assets/order-tutorial-bg2.png';

export const OrderTutorialContainer = styled(Container)`
  padding: 50px 50px 50px 50px;
  /* background-color: ${BACKGROUND_COLOR}; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-image: url(${OrderTutorialBg});
  background-size: cover;
  @media (max-width: 1120px) {
    padding: 50px 20px;
  }

  /* @media (max-width: 800px) {
    flex-direction: column;
  } */
`

export const OrderTutorialButton = styled(Button)`
  display: block;
  font-size: inherit;
  color: ${WHITE};
  text-decoration: none;
  text-align: left;
  padding: 0.7rem 1rem;
  background-color: ${PRIMARY};
  margin-right: 10px;
  border: none;
  border-radius: 8px;
  position: relative;
  /* width: 100%; */
  font-family: 'FigtreeBold', 'sans-serif';
  transition: background-color 0.3s ease-in, color 0.3s ease-in;
  text-align: center;
  align-self: center;
  margin-top: 50px;

  &:hover {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
    transition: background-color 0.3s ease-out, color 0.3s ease-out;
  }

  &:active {
    color: ${BLACK} !important;
    background-color: ${HOVER_ITEM_COLOR} !important;
    border-color: none !important;
  }

  &:disabled {
    color: ${BLACK} !important;
    background-color: ${HOVER_ITEM_COLOR} !important;
    border-color: none !important;
  }
`

export const OrderTutorialHeader = styled.h3`
  font-family: 'FigtreeBold', sans-serif;
  font-size: 1.8rem;
  color: ${WHITE};
  /* opacity: 0.8; */
  text-align: center;
  margin-bottom: 50px;
`;

export const OrderTutorialList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 800px) {
    flex-direction: column;
    gap: 1.2rem;
  }
`;

export const OrderTutorialItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 250px;
  height: 100%;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  border-radius: 16px;
  background-color: #c4d4e9;

  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    transform: translate(0px, -3.99328px);
  }

  @media (max-width: 800px) {
    gap: 0rem;
  }
`

export const OrderTutorialImage = styled.img`
  width: 100%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  @media (max-width: 800px) {
    margin-bottom: 20px;
  }
`

export const OrderTutorialItemList = styled.ul`
  height: 120px;
`;

export const OrderTutorialItemListItem = styled.li`
  font-family: 'FigtreeBold', sans-serif;
  font-size: 1rem;
  color: ${BLACK};
  opacity: 0.8;
`

export const OrderTutorialTitle = styled.p`
  padding: 8px;
  border-radius: 12px;
  font-family: 'FigtreeBold', 'sans-serif';
  font-size: 1rem;
  text-align: center;
  height: 120px;
`